/*eslint-disable*/
import { HamburgerIcon } from "@chakra-ui/icons";
// chakra imports
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  Avatar,
  useToken,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  AspectRatio,
  ModalBody,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { SpotifyLogo } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ProfileIcon } from "components/Icons/Icons";
import { useSelector, shallowEqual } from "react-redux";
import InfoPanel from "./InfoPanel";
import { getTutorialVideo } from "constants/Tutorialvideos";

function SidebarResponsive(props) {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  const authStore = useSelector((store) => store.auth, shallowEqual);
  const { authUser } = authStore;

  let navbarIcon = useColorModeValue("gray.500", "gray.200");
  const mainPanel = React.useRef();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName) ? "active" : "";
  };

  const createLinks = (routes) => {
    // Chakra Color Mode
    const activeBg = useColorModeValue("white", "gray.700");
    const inactiveBg = useColorModeValue("white", "gray.700");
    const activeColor = useColorModeValue("gray.700", "white");


    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.separator) return;
      if (prop.category) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{
                xl: "12px",
              }}
              mx="auto"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py="10px"
            >
              {prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      return (
        <NavLink to={prop.path} key={prop.name}>
          {activeRoute(prop.path) === "active" ? (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg={"sidebar_select_div"}
              mb={{
                base: "5px",
                xl: "12px",
              }}
              mx={{
                xl: "auto",
              }}
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py="10px"
              mr={3}
              borderRadius="8px"
              _hover="none"
              w="90%"
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox
                    bg="sidebar_select_icon_bg"
                    color="sidebar_select_icon_color"
                    h="30px"
                    w="30px"
                    me="12px"
                  >
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={"sidebar_select_text"} my="auto" fontSize="sm">
                  {prop.name}
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              mb={{
                base: "5px",
                xl: "12px",
              }}
              mx={{
                xl: "auto",
              }}
              py="10px"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              borderRadius="8px"
              mr={3}
              _hover={{
                bg: "sidebar_hover",
                color: "white",
              }}
              w="90%"
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
            >
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Icon>{prop.icon}</Icon>
                ) : (
                  <IconBox
                    bg={"sidebar_unselect_icon_bg"}
                    color="sidebar_unselect_icon_color"
                    h="30px"
                    w="30px"
                    me="12px"
                  >
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={"sidebar_unselect_text"} my="auto" fontSize="sm">
                  {prop.name}
                </Text>
              </Flex>
            </Button>
          )}
        </NavLink>
      );
    });
  };

  const { logoText, routes, ...rest } = props;

  const sidebarRadius = "16px";

  var links = <>{createLinks(routes)}</>;
  //  BRAND
  //  Chakra Color Mode

  let hamburgerColor = useColorModeValue("gray.500", "gray.200");
  if (props.secondary === true) {
    hamburgerColor = "white";
  }
  const { isOpen, onOpen, onClose } = useDisclosure();
  var brand = <InfoPanel onCloseDrawer={onClose} />;

  // SIDEBAR

  const btnRef = React.useRef();
  const boxShadow = useToken("colors", ["navbar_logout_button_shadow"]);
  // Color variables

  const {
    isOpen: isVideoOpen,
    onOpen: onVideoOpen,
    onClose: onVideoClose,
  } = useDisclosure();
  // ویدیوی آموزشی متناظر با صفحه‌ی فعلی (نگاشت در constants/tutorialVideos.js)
  const TUTORIAL_VIDEO_URL = getTutorialVideo(location.pathname);

  
  return (
    <Flex
      display={{ base: "flex", lg: "none" }}
      ref={mainPanel}
      gap={2}
      alignItems="center"
    >
      <Button
        w={1}
        bg={"infopanel_theme_bg"}
        boxShadow={boxShadow}
        borderRadius={8}
        onClick={onOpen}
        ref={btnRef}
      >
        <HamburgerIcon
          color={"sidebar_select_icon_bg"}
          w="20px"
          h="20px"
          ref={btnRef}
          colorScheme="teal"
          onClick={onOpen}
        />
      </Button>
       {TUTORIAL_VIDEO_URL && (
       <Button
        fontSize={"xs"}
        ml={{ base: 2, md: 2 }}
        size={"sm"}
        bg={"button_teal_bg"}
        color ="button_teal_color"
        _hover={{
          
          bg : "button_teal_hover",
          
        }}
        colorScheme="teal"
        borderRadius={"6px"}
        onClick={onVideoOpen}
      >
        ویدیو آموزشی
      </Button>
       )}

      {TUTORIAL_VIDEO_URL && (
      <Modal isOpen={isVideoOpen} onClose={onVideoClose} size="6xl" isCentered>
        <ModalOverlay
  bg="blackAlpha.300"
  backdropFilter="blur(8px)"
/>
        <ModalContent bg="black" borderRadius="12px" overflow="hidden">
          <ModalCloseButton color="white" zIndex={1} />
          <ModalBody p={0}>
            <AspectRatio ratio={16 / 9}>
              <video
                src={TUTORIAL_VIDEO_URL}
                controls
                autoPlay
                style={{ width: "100%", height: "100%" }}
              >
                این ویدیو توسط مرورگر شما پشتیبانی نمی‌شود
              </video>
            </AspectRatio>
          </ModalBody>
        </ModalContent>
      </Modal>
      )}
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay
          backdropFilter="blur(5px)"
  bg="rgba(0,0,0,0.2)"
        />
        <DrawerContent w="300px" maxW="300px">
          <DrawerBody maxW="300px" px="1rem" bg={"sidebar"}>
            <Box maxW="100%" minH="calc(100vh - 64px)">
              <Box>{brand}</Box>
              <Stack direction="column" mb="40px">
                <Box>{links}</Box>
              </Stack>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

export default SidebarResponsive;